"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const react_query_1 = require("@tanstack/react-query");
const react_1 = require("react");
const react_router_1 = require("react-router");
const appConstants_1 = require("../../../../constants/appConstants");
const strings_1 = require("../../../../constants/strings");
const uiConstants_1 = require("../../../../constants/uiConstants");
const codingQuery_1 = require("../../../../queries/codingQuery");
const companyQuery_1 = require("../../../../queries/companyQuery");
const userQuery_1 = require("../../../../queries/userQuery");
const pageLoader_1 = __importDefault(require("../../../../router/loaders/pageLoader"));
const codingFooterSection_1 = __importDefault(require("./codingFooterSection"));
const codingHeaderSection_1 = __importDefault(require("./codingHeaderSection"));
const codingTableSection_1 = __importDefault(require("./codingTableSection"));
const companySettingsCodingDialog_1 = __importDefault(require("./companySettingsCodingDialog"));
const useCodingListState_1 = require("./kooks/useCodingListState");
const noCodingListSection_1 = __importDefault(require("./noCodingListSection"));
const SelectTeamsAside = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./selectTeamsAside'))));
const RenameCustomCodingListAside = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./renameCustomCodingListAside'))));
const CreateCodingListAside = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./createCodingListAside'))));
const CreateCustomCodingListAside = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./createCustomCodingListAside'))));
const PREDEFINED_CODING_LISTS = appConstants_1.codingListConstants.predefinedCodingLists;
function getDisabled(selectedCodingList) {
    // We can not delete a predefined list
    return PREDEFINED_CODING_LISTS.map(list => list.id).includes(selectedCodingList.id || '');
}
const CompanySettingsCodingTemplate = () => {
    const state = (0, useCodingListState_1.useCodingPageState)();
    const initialData = (0, react_router_1.useLoaderData)();
    const { data: userData } = (0, react_query_1.useQuery)({
        ...userQuery_1.userQuery,
        ...(initialData && 'user' in initialData && { initialData: initialData?.user }),
    });
    const { data: companyPropertiesData } = (0, react_query_1.useQuery)((0, companyQuery_1.companyPropertiesQuery)(userData?.companyAccountId, {
        cardprovider: 'tsgo-cardprovider',
    }));
    const cardProvider = companyPropertiesData?.cardprovider;
    const isAmexCardProvider = cardProvider === 'AMEX';
    const { data: codingLists = [] } = (0, react_query_1.useQuery)({
        ...(0, codingQuery_1.getCodingListsQuery)({ skipDisabled: false }),
        ...(initialData && 'codingLists' in initialData && { initialData: initialData?.codingLists }),
    });
    const disableCodingListQuery = (0, codingQuery_1.useDisableCodingListQuery)();
    const updateCodingListQuery = (0, codingQuery_1.useUpdateCodingListQuery)();
    const onCreateNewCodingListButtonClick = (0, react_1.useCallback)(value => {
        state.setIsCreateCodinglistAsideOpen(false);
        updateCodingListQuery.mutate({ codingList: value }, {
            onSuccess: () => {
                state.setCurrentCodingListSelected({ ...value, enabled: false });
                disableCodingListQuery.mutate({ codingListCode: value.id });
            },
        });
    }, [state.setIsCreateCodinglistAsideOpen, state.setCurrentCodingListSelected, updateCodingListQuery]);
    const openCreateCodingListAside = (0, react_1.useCallback)(() => {
        state.setIsCreateCodinglistAsideOpen(true);
    }, [state.setIsCreateCodinglistAsideOpen]);
    const openRenameCustomCodingListAsideFunc = (0, react_1.useCallback)(() => {
        state.setIsRenameCustomCodingListAsideOpen(true);
    }, [state.currentCodingListSelected.name]);
    const openRemoveListConfirmationAside = (0, react_1.useCallback)(() => {
        state.setIsRemoveCodingListAsideOpen(true);
    }, [state.setIsRemoveCodingListAsideOpen]);
    (0, react_1.useEffect)(() => {
        state.setFooterButtons([
            {
                id: 'createList',
                dataTestId: 'createNewList-btn',
                label: strings_1.companySettingsCodingStrings.CREATE_NEW_LIST_BUTTON,
                color: uiConstants_1.UI_BUTTON_PRIMARY,
                onclick: openCreateCodingListAside,
            },
            {
                id: 'removeList',
                dataTestId: 'removeList-btn',
                label: strings_1.companySettingsCodingStrings.REMOVE_LIST_BUTTON,
                color: uiConstants_1.UI_BUTTON_SECONDARY,
                onclick: openRemoveListConfirmationAside,
                disabled: getDisabled(state.currentCodingListSelected),
            },
            {
                id: 'renameList',
                dataTestId: 'renameList-btn',
                label: strings_1.companySettingsCodingStrings.RENAME_LIST_BUTTON,
                color: uiConstants_1.UI_BUTTON_SECONDARY,
                onclick: openRenameCustomCodingListAsideFunc,
                disabled: getDisabled(state.currentCodingListSelected),
            },
        ]);
    }, [state.currentCodingListSelected]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(material_1.Paper, { "ts-variant": "container", children: codingLists?.length === 0 ? ((0, jsx_runtime_1.jsx)(noCodingListSection_1.default, { openCreateCodingListAside: openCreateCodingListAside })) : ((0, jsx_runtime_1.jsxs)(material_1.Paper, { variant: "outlined", "ts-variant": "modal", children: [(0, jsx_runtime_1.jsx)(codingHeaderSection_1.default, {}), (0, jsx_runtime_1.jsx)(codingTableSection_1.default, {})] })) }), codingLists?.length ? (0, jsx_runtime_1.jsx)(codingFooterSection_1.default, { selectedCodingList: state.currentCodingListSelected }) : '', (0, jsx_runtime_1.jsx)(react_1.Suspense, { fallback: (0, jsx_runtime_1.jsx)("div", {}), children: isAmexCardProvider ? ((0, jsx_runtime_1.jsx)(CreateCodingListAside, { codingLists: codingLists, onCreateNewCodingListButtonClick: onCreateNewCodingListButtonClick })) : null }), (0, jsx_runtime_1.jsx)(react_1.Suspense, { fallback: (0, jsx_runtime_1.jsx)("div", {}), children: (0, jsx_runtime_1.jsx)(CreateCustomCodingListAside, {}) }), (0, jsx_runtime_1.jsx)(react_1.Suspense, { fallback: (0, jsx_runtime_1.jsx)("div", {}), children: (0, jsx_runtime_1.jsx)(RenameCustomCodingListAside, { selectedCodingList: state.currentCodingListSelected }) }), (0, jsx_runtime_1.jsx)(react_1.Suspense, { fallback: (0, jsx_runtime_1.jsx)("div", {}), children: (0, jsx_runtime_1.jsx)(SelectTeamsAside, {}) }), (0, jsx_runtime_1.jsx)(react_1.Suspense, { fallback: (0, jsx_runtime_1.jsx)(pageLoader_1.default, {}), children: (0, jsx_runtime_1.jsx)(companySettingsCodingDialog_1.default, {}) })] }));
};
exports.default = CompanySettingsCodingTemplate;
